
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/annonces-legales",
      function () {
        return require("private-next-pages/annonces-legales.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/annonces-legales"])
      });
    }
  